import {FBFieldBase} from "../../../Fields/Core/FBFieldBase";
import {ComparisonTypeEnum} from "../../../Fields/Core/ConditionOptions";


export interface RetrieverSource {
    GetValue();
    GetIsUsed():boolean;
    GetIsVisible():boolean;
    GetPrice():number;
    GetText():string;

}

export abstract class ValueRetrieverBase {
    constructor(public Source:RetrieverSource)
    {

    }

    public abstract GetValue();

    public GetPrice(){
        return this.Source.GetPrice();
    }

    public GetText()
    {
        return this.Source.GetText();
    }


    public abstract Compare(Comparison: ComparisonTypeEnum, Value: any);


}

